'use client'

import NoData from "@/Component/Common/Tables/NoData/NoData";
import Loader from "@/Layout/Loader";
import CustomFetch from "@/Utils/APIRequest/AxiosInstance";
import { AdminFAQsAPI } from "@/Utils/APIRequest/Endpoints";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import FaqAccordion from "./FaqAccordion";
import { useTranslation } from "@/Utils/Hooks/useTranslate";

const Faq = () => {
  const [params, setParams] = useState({ page: 1, per_page: 50, sort_by: "", sort: "DESC" })
  const [activeFaq, setActiveFaq] = useState('')
  const { translations } = useTranslation();

  const { data: FaqAPIData, isPending } = useQuery({ queryKey: [AdminFAQsAPI, params], queryFn: () => CustomFetch({ url: AdminFAQsAPI, params: { ...params } }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data })

  if (isPending) {
    return <Loader />
  }
  return (
    <>
      <h2 className="text-primary text-xl mb-7 font-medium leading-6">❓ {translations?.faqs}</h2>
      <div className="bg-gray-100 flex justify-center">
        <div className="max-w-full mx-auto w-full">
          <ul className="shadow-box">
            {
              FaqAPIData?.data?.length > 0 ?
                FaqAPIData?.data?.map((faq) => (
                  <FaqAccordion faq={faq} key={faq.id} activeFaq={activeFaq} setActiveFaq={setActiveFaq} />
                ))
                : <NoData />
            }
          </ul>
        </div>
      </div>
    </>
  );
};

export default Faq;
